import { Record } from 'immutable';

const BrandRecord = Record({
    brandCode: null,
    name: null
});

export class Brand extends BrandRecord {
    brandCode: string;
    name: string;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/chain-brand/brand.ts